import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { InfoPopupHeader } from './info_popup_header';
import { InfoPopupBody } from './info_popup_body';
import { InfoPopupDispatcher } from '../../../_constants/info_popup';

function InfoPopup(props) {
  return (
    <Lightbox
      opened={props.visible}
      onClose={props.onCloseClick}
      additionalClassNames={
        props.dispatcher === InfoPopupDispatcher.BUY_4_PAY_3
          ? ['voucher-code-light-box__lightbox']
          : ['info-popup-lightbox']
      }
      activePage={'info-layer'}
      hideCloseButton={!props.showCloseButton}
    >
      <div className={props.dispatcher === InfoPopupDispatcher.BUY_4_PAY_3 ? '' : 'info-popup'}>
        <InfoPopupHeader
          dispatcher={props.dispatcher}
          headerContent={props.headerContent}
          onBackClick={props.bodyButtonOnClick}
          showCloseButton={props.showCloseButton}
        />
        <InfoPopupBody
          staticUrl={TYROOLA.globals.staticImagesUrl}
          bodyContent={props.bodyContent}
          dispatcher={props.dispatcher}
          bodyButtonText={props.bodyButtonText}
          bodyButtonOnClick={props.bodyButtonOnClick}
          bodyUpperImagePath={props.bodyUpperImagePath}
          bodyLowerImagePath={props.bodyLowerImagePath}
        />
      </div>
    </Lightbox>
  );
}

InfoPopup.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  headerContent: PropTypes.string.isRequired,
  bodyContent: PropTypes.array.isRequired,
  bodyButtonText: PropTypes.string.isRequired,
  bodyButtonOnClick: PropTypes.func.isRequired,
  bodyUpperImagePath: PropTypes.string,
  bodyLowerImagePath: PropTypes.string,
};

InfoPopup.defaultProps = {
  bodyUpperImagePath: '',
  bodyLowerImagePath: '',
  bodyContent: [],
};

export { InfoPopup };
